import { Info } from 'lucide-react'

export function LiveCampaignBanner() {
  return (
    <div className="flex items-start gap-2.5 rounded-lg bg-info-bg p-3.5">
      <Info className="mt-0.5 size-4 shrink-0 text-info" />
      <div>
        <p className="text-sm font-medium text-fg">This campaign is live.</p>
        <p className="mt-0.5 text-xs text-fg-secondary">
          Changes will apply to future sends only. Contacts who have already
          received a step won&apos;t be affected.
        </p>
      </div>
    </div>
  )
}
